import { useSetAtom, WritableAtom } from 'jotai';

/**
 * Jotai의 useResetAtom 대체 hook
 * Recoil의 useResetRecoilState를 Jotai로 마이그레이션하기 위한 커스텀 hook
 *
 * 사용법:
 * const resetMyInfo = useResetAtom(MyInfoState, INIT_MY_INFO);
 * resetMyInfo(); // atom을 초기값으로 리셋
 *
 * @param atom - 리셋할 Jotai atom
 * @param initialValue - atom의 초기값
 */
export function useResetAtom<Value>(
  atom: WritableAtom<Value, [Value], void>,
  initialValue: Value,
) {
  const setAtom = useSetAtom(atom);
  return () => setAtom(initialValue);
}
